<div class="setup-checklist">

  <!-- Header -->
  <div class="setup__header">
    <div class="setup__title-row">
      <div class="setup__icon">
        <i class="pi pi-flag"></i>
      </div>
      <div class="setup__title-text">
        <h3 class="setup__title">Termine de configurar sua empresa</h3>
        <p class="setup__subtitle">Complete as etapas abaixo para começar a usar o Manager</p>
      </div>
    </div>
    <button
      class="setup__dismiss"
      (click)="onDispensar()"
      pTooltip="Ocultar checklist"
      tooltipPosition="left"
      [tooltipStyleClass]="'menu-tooltip'">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <!-- Barra de progresso -->
  <div class="setup__progress">
    <div class="setup__progress-info">
      <span class="setup__progress-label">{{ concluidos }} de {{ total }} concluídos</span>
    </div>
    <div class="setup__progress-bar">
      <div class="setup__progress-fill" [style.width.%]="progressPercent"></div>
    </div>
  </div>

  <!-- Toggle expand/collapse -->
  <button class="setup__toggle" (click)="toggleExpanded()">
    <span>{{ expanded ? 'Ocultar etapas' : 'Ver etapas' }}</span>
    <i class="pi" [ngClass]="expanded ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
  </button>

  <!-- Items (colapsável) -->
  <div class="setup__items" [class.setup__items--expanded]="expanded">
    <a
      *ngFor="let item of items"
      class="setup__item"
      [class.setup__item--done]="item.concluido"
      [routerLink]="item.link"
      [queryParams]="item.queryParams">

      <div class="setup__check">
        <i *ngIf="item.concluido" class="pi pi-check"></i>
      </div>

      <div class="setup__item-content">
        <span class="setup__item-label">{{ item.label }}</span>
        <span class="setup__item-desc">{{ item.descricao }}</span>
      </div>

      <i class="pi pi-arrow-right setup__item-arrow"></i>
    </a>
  </div>

</div>
